import { render, staticRenderFns } from "./ReportAccordion.vue?vue&type=template&id=74f24129&scoped=true&"
import script from "./ReportAccordion.vue?vue&type=script&lang=ts&"
export * from "./ReportAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f24129",
  null
  
)

export default component.exports